import React from "react";
import { ToastContainer } from "react-toastify";
import { ManageCategory } from "../../../components/MasterSettings/Category/ManageCategory";
export const CategoryManage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageCategory />
        </div>
      </div>
    </div>
  );
};